import * as Sentry from '@sentry/react'
import { DEPLOY_SKEW_TAG } from './chunkLoadError'
import { newVersionStore } from './NewVersionStore'

/** Turns Vite's failed chunk preloads into a new-version banner instead of an uncaught error. */
export function registerPreloadErrorHandler() {
   window.addEventListener('vite:preloadError', event => {
      event.preventDefault()
      Sentry.captureException(event.payload, { tags: { [DEPLOY_SKEW_TAG]: 'chunk' } })
      newVersionStore.announce()
   })
}
